import * as React from 'react';
import { Grid, StyledComponentProps, withStyles } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import { styles } from '../../styles';
import Button from '../../../../ui-components/Button/Button';

interface IProps extends StyledComponentProps {
    // handleChangeFullnameOrEmail: (val: string) => void;
    // handleChangeSub: (val: string) => void;
    search: (fullnameOrEmail?: string, sub?: string) => void;
    // fullnameOrEmail?: string;
    // sub?: string;
    loading: boolean;
    // classes: any;
}

interface IState {
    sub?: string;
    fullnameOrEmail?: string;
}

class Filters extends React.Component<IProps, IState> {

    state = {
        sub: "",
        fullnameOrEmail: "",
    };

    reset = () => {
        this.handleChangeFullnameOrEmail(null);
        this.handleChangeSub(null);
        this.props.search(null, null);
    }

    handleChangeFullnameOrEmail = (val: string) => {
        this.setState({ fullnameOrEmail: val })
    }

    handleChangeSub = (val: string) => {
        this.setState({ sub: val })
    }

    render() {
        const classes = this.props.classes;
        return (
            <Grid container className={classes.root} spacing={2}>
                <Grid item xs={12} sm={4} >
                    <TextField label='Cognome Nome o Email'
                        onKeyDown={(e) => {
                            // Enter KeyCode = 13
                            if (e.keyCode === 13) {
                                this.props.search(this.state.fullnameOrEmail, "")
                            }
                        }}
                        onChange={this.handleChangeFullnameOrEmail}
                        value={this.state.fullnameOrEmail}
                        disabled={this.props.loading} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField label='Sub'
                        disabled={this.props.loading}
                        onChange={this.handleChangeSub}
                        value={this.state.sub} />
                </Grid>
                <Grid item xs={3} sm={4} className={classes.searchButtons} >
                    <div className={classes.searchButton}>
                        <Button className={classes.searchButton}
                            onClick={() => this.props.search(this.state.fullnameOrEmail, this.state.sub)}>Cerca</Button>
                        <span>&nbsp;</span>
                        <Button className={classes.searchButton}
                            onClick={this.reset}>Reset</Button>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(Filters)